import {ADD, REMOVE, EDIT, REMOVE_ALL} from './types'

export function add (adverseReaction) {
  return {
    type: ADD,
    payload: adverseReaction
  }
}

export function edit (id, adverseReaction) {
  return {
    type: EDIT,
    payload: {
      id,
      data: adverseReaction
    }
  }
}

export function remove (id) {
  return {
    type: REMOVE,
    payload: id
  }
}

export function removeAll () {
  return {
    type: REMOVE_ALL
  }
}
